
import ProductHome from '../components/Products/ProductHome'
import ProductList from '../components/Products/ProductList'
import CustomPlatform from '../components/Products/CustomPlatform'
import { SEO } from '../utils/SEO'

export default function Products() {
    SEO({
        title: 'Software Products | SAN Technovation',

        description:
            'Explore SAN Technovation software products including CareerConnect ATS, CareerConnect AI, SAN HRMS, and SAN LMS. Discover recruitment, HR, learning management, and business automation solutions for modern organizations.',

        keywords:
            'SAN Technovation, SAN Technovation Products, Software Products, CareerConnect ATS, CareerConnect AI, SAN HRMS, SAN LMS, Applicant Tracking System, Recruitment Software, Job Portal Software, HRMS Software, Human Resource Management System, Learning Management System, LMS Software, ATS Software, Business Automation, Enterprise Software, Digital Solutions, Custom Software Development, Workforce Management',

        author: 'SAN Technovation',

        ogTitle:
            'Software Products | SAN Technovation',

        ogDescription:
            'Discover SAN Technovation software products including CareerConnect ATS, CareerConnect AI, SAN HRMS, and SAN LMS for recruitment, HR management, learning, and business automation.',

        ogType: 'website',

        ogSiteName: 'SAN Technovation',

        canonical: 'https://www.santechnovation.com/product'
    })
    return (

        <main>
            <ProductHome />
            <ProductList />
            <CustomPlatform />
        </main>
    )
}



